'use strict';

/* jshint esnext: true, loopfunc: true */

var objectUtils = require('./object');

module.exports = objectUtils.extend({
        global: require('./global')
}, objectUtils, require('./array'), require('./number'), require('./string'), require('./type'));


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-lang/index.js
 ** module id = 10
 ** module chunks = 0 1
 **/